import {
  FilterMode,
  TenantStorageUsage_OrderBy,
  TenantStorageUsage,
  SortOrder,
  TenantStorageUsage_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const tenantStorageUsageService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantStorageUsageOne({ id });
    return result.tenantStorageUsageOne as TenantStorageUsage;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantStorageUsage_OrderBy[] | null = null,
    filter: TenantStorageUsage_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantStorageUsage_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantStorageUsageListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantStorageUsageListWithOffset
    ) as TenantStorageUsage[];
    return { list, orderBy };
  },
};
